/**
 * firebaseAuth — Helper compartido para obtener headers con el token real de
 * Firebase. Firebase entrega el ID token en el momento (NO se guarda en
 * localStorage). Este es el patrón correcto para endpoints que exigen auth
 * estricta (require_role / get_current_user en el backend).
 *
 * Uso:
 *   import { getFirebaseAuthHeaders } from '../common/firebaseAuth';
 *   const headers = await getFirebaseAuthHeaders();
 *   const r = await fetch(url, { headers });
 */
import { getAuth } from 'firebase/auth';

export async function getFirebaseAuthHeaders() {
  const user = getAuth().currentUser;
  const token = user ? await user.getIdToken() : null;
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}
